import '../../organisms/slideOnboarding/styles.scss'
// components
import Card from '../../../../../components/atoms/card/card'
import { CardProgram } from '../CardProgram'
import { IconClose } from '../IconClose'
import { ArrowUpIcon } from '../../atoms/icons/arrows'
import RichText from '../../../../../components/atoms/rich-text/rich-text'

export const ThirdStep = ({ onClick, contentData, gotoNext }) => {
	return (
		<div className='container-item-slider' onClick={gotoNext}>
			<section className='container-item-slider section-flex container-between'>
				<IconClose onClick={onClick} />
				<div style={{ marginTop: '12rem' }}>
					<CardProgram programName='Riesgo cardiovascular' classes='t-program__card morphism' />
				</div>
				<div className='container-arrow__second-step'>
					<ArrowUpIcon />
				</div>
				<div className='pb3'>
					<Card classes='morphism'>
						{contentData && (
							<RichText data={contentData} isContent classes='card-text mt-onboarding-program' />
						)}
					</Card>
				</div>
			</section>
		</div>
	)
}
